module.exports = __webpack_public_path__ + "img/614.2898b5fc.jpg";